import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-accept-quote-line-dialog',
  templateUrl: './accept-quote-line-dialog.component.html',
  styleUrls: ['./accept-quote-line-dialog.component.scss']
})
export class AcceptQuoteLineDialogComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
